export interface PurchaseNotice {
  name: string
  city: string
  minutesAgo: number
}

export const purchases: PurchaseNotice[] = [
  { name: 'Micaela', city: 'Córdoba, Argentina', minutesAgo: 2 },
  { name: 'Fernanda', city: 'Ciudad de México, México', minutesAgo: 4 },
  { name: 'Carla', city: 'Montevideo, Uruguay', minutesAgo: 6 },
  { name: 'Paula', city: 'Bogotá, Colombia', minutesAgo: 3 },
  { name: 'Sofía', city: 'Santiago, Chile', minutesAgo: 8 },
  { name: 'Andrea', city: 'Lima, Perú', minutesAgo: 5 },
  { name: 'Julieta', city: 'Rosario, Argentina', minutesAgo: 7 },
  { name: 'Gabriela', city: 'Guayaquil, Ecuador', minutesAgo: 9 },
  { name: 'Verónica', city: 'Buenos Aires, Argentina', minutesAgo: 3 },
  { name: 'Natalia', city: 'Medellín, Colombia', minutesAgo: 11 },
  { name: 'Romina', city: 'Mendoza, Argentina', minutesAgo: 6 },
  { name: 'Lucía', city: 'Asunción, Paraguay', minutesAgo: 12 },
  { name: 'Daniela', city: 'Guadalajara, México', minutesAgo: 4 },
  { name: 'Camila', city: 'Valparaíso, Chile', minutesAgo: 10 },
  { name: 'Mariela', city: 'San José, Costa Rica', minutesAgo: 7 },
]
